import mutations from './mutations';
import actions from './actions';
import getters from './getters';
const SyaratJenis = {
    namespaced: true,
    state : {},
    mutations,
    actions,
    getters
}

export default SyaratJenis;